"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexgridLeft = exports.Nav = exports.Header = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Header = styled_components_1.default.header `
	height: ${(p) => p.theme.navHeight}px;
	color: ${(p) => p.theme.palette.text.primary};
	font-size: 14px;
	font-family: ${(p) => p.theme.fonts.default};
	text-rendering: optimizelegibility;
	font-feature-settings: "kern";
	-webkit-font-smoothing: subpixel-antialiased;
	max-width: 100%;
	overflow-x: hidden;

	a {
		color: ${(p) => p.theme.palette.text.primary};
		font-size: 11px;
		letter-spacing: 1.05px;
		line-height: 16px;
		display: inline-block;
		text-transform: uppercase;
		text-decoration: none;
		&:hover {
			color: ${(p) => p.theme.palette.text.primary};
			text-decoration: none;
		}
	}

	a > .h3 {
		letter-spacing: initial;
	}

	* {
		box-sizing: border-box;
		&:focus {
			outline-style: groove;
			outline-color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
			outline-offset: -2px;
		}
	}
`;
exports.Nav = styled_components_1.default.div `
	.nav-inner {
		background: ${(p) => p.theme.palette.background.default};
		display: flex;
		justify-content: space-between;
		height: ${(p) => p.theme.navHeight}px;
		padding: 0;
		position: absolute;
		overflow: visible;
		max-width: 100%;
		top: ${(p) => `${p.topOffset}px` || 0};
		left: 0;
		right: 0;
		z-index: 9000;
		font-size: 100%;
	}

	&.search-open {
		background: ${(p) => p.theme.palette.background.default};
	}
`;
exports.FlexgridLeft = styled_components_1.default.div `
	display: flex;
`;
//# sourceMappingURL=EpicGamesNav.styles.js.map